export const MODAL_NAMES = {
  CART_COLLECTION_POINTS: 'CART_COLLECTION_POINTS',
  CATCH_UP_INSURANCE_OFFER: 'CATCH_UP_INSURANCE_OFFER',
  VISIBLE_BY_VERIZON_PROMO_CODE: 'VISIBLE_BY_VERIZON_PROMO_CODE',
  RAKUTEN_PROMO_CODE: 'RAKUTEN_PROMO_CODE',
  GOOGLE_FI_PROMO_CODE: 'GOOGLE_FI_PROMO_CODE',
  NOBLE_PROMO_CODE: 'NOBLE_PROMO_CODE',
  BACK_MARKET_PROMISE: 'BACK_MARKET_PROMISE',
}

export const DEBOUNCE_DELAY = 250
